<template>
	<div class="login">
		<b-container>
			<b-row>
				<b-col cols="12">
					<div class="header text-center">
						<h2 class="mt-5 pt-md-5">HOUSEKEEPING</h2>
						<div class="len_typed position-absolute w-100">
							<p class="color-green text-center m-0">
								<b v-html="len_typed"></b>
							</p>
						</div>
					</div>
					<div class="login-container d-table mt-5 pt-3 mx-auto">
						<div class="d-table-cell align-middle">
							<div v-for="(b, idx) in buttons" :key="idx"
								class="button color-green d-inline-block cursor-pointer pl-1 pr-1"
								v-on:click="b.func(b.num)">
								<div class="d-table mx-auto button-inner w-100" :class="b.class">
									<div class="d-table-cell align-middle text-center">
										<span v-if="b.display_text == 'ENTRAR'">{{ trans['ENTRAR_UC'] }}</span>
										<span v-else>{{ b.display_text }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>

export default {
	name: 'login',
	props: ['data'],
	data() {
		return {
			code_typed: '',
			loading: false,
			buttons: [],
			app_token: 'Bearer ' + process.env.VUE_APP_TOKEN
		}
	},
	components: {
		// HelloWorld
	},
	methods: {
		process_login: function (clicked) {
			if (this.$distribution !== null && typeof this.$distribution.zones !== 'undefined') {
				let rooms_changed = [];

				for (let z of this.$distribution.zones) {
					rooms_changed = rooms_changed.concat(z.rooms.filter((item, idx) => item.saved == 0));
				}

				if (rooms_changed.length > 0) {
					this.send_data(rooms_changed, true);
					return;
				}
			}
			this.login(clicked);
		},
		login: function (clicked) {
			let code = '';
			if (clicked) {
				code = this.pin;
			} else {
				code = localStorage.getItem('code');
				if (!code) {
					code = this.pin;
				}
			}

			this.$http.post('housekeeping/login',
				{
					pin: code
				},
				{
					headers: {
						Authorization: this.app_token
					},
					before(request) {
						this.$emit('set_loading', true);
					}
				})
				.then(resp => {
					
					// Set essencial login data
					resp.body.data.person.login_time = Math.round(+new Date() / 1000); // unix timestamp
					this.$storage.set('data', resp.body.data);
					localStorage.setItem('hotels', JSON.stringify(resp.body.hotels));
					localStorage.setItem('is_logged', '1');
					localStorage.setItem('code', code);
					localStorage.setItem('user_lang', resp.body.data.person.language.lang);
					localStorage.setItem('rooms_status', JSON.stringify(resp.body.rooms_status));
					localStorage.setItem('extra_beds', JSON.stringify(resp.body.extra_beds));			
	  				localStorage.setItem('current_hotel', resp.body.data.person.localization.cod_hotel);
					
					this.$distribution = resp.body.data;

					this.$emit('login');

					if( !resp.body.data.cod_distribution ){
						this.$router.push({
							name: 'no_distribution',
							params: {
								lang: resp.body.data.person.language.lang,
								message: resp.body.message,
								search_hotel: resp.body.data.person.localization.cod_hotel,
								search_bloco: null,
								search_piso: null,
								search_n_quarto: null
							}
						});
						return;
					}

					// if is housekeeper supervisor
					if (resp.body.data.person.view_all == 1) {
						this.$router.push({
							name: 'list_zones',
							params: {
								zones: resp.body.data.zones,
								lang: resp.body.data.person.language.lang,
								search_hotel: resp.body.data.person.localization.cod_hotel,
								search_bloco: null,
								search_piso: null,
								search_n_quarto: null
							}
						});
						return;
					} 

					// if is housekeeper
					if (resp.body.data.zones) {
						this.$router.push({
							name: 'list_rooms',
							params: {
								cod_dist_zone: resp.body.data.zones[0].cod_distribution_zone,
								dist: resp.body.data.zones[0],
								lang: resp.body.data.person.language.lang,
								search_hotel: resp.body.data.person.localization.cod_hotel,
								search_bloco: null,
								search_piso: null,
								search_n_quarto: null
							}
						});
						return;

					}

					this.$router.push({
						name: 'list_rooms', params: {
							cod_dist_zone: null,
							dist: null,
							lang: null,
							search_hotel: null,
							search_bloco: null,
							search_piso: null,
							search_n_quarto: null
						}
					});
					return;

				}, resp => {
					this.$bvToast.toast(resp.body.message, {
						title: 'Erro',
						variant: 'danger',
						solid: true
					})
				}).then(resp => {
					this.$emit('set_loading', false);
				});
		},
		send_data: function (items, do_login) {
			if (items.length > 0) {
				this.$http.post('housekeeping/update_rooms?token=' + this.$distribution.person.token,
					{
						rooms: items
					},
					{
						before(request) {
							//this.loading = true;
						}
					})
					.then(resp => {
						this.$distribution = null;
						localStorage.removeItem('data');
						localStorage.removeItem('rooms_status');
						localStorage.removeItem('extra_beds');
						this.$emit('set_loading', false);

						if (do_login) {
							this.login();
						}

					}, resp => {
						/*this.$bvToast.toast(resp.body.message, {
						  title: 'Erro',
						  variant: 'danger',
						  solid: true
						})*/
					}).then(resp => {

					});
			}
		}
	},
	computed: {
		len_typed: function () {
			return '<span class="asterisc pr-4">*</span>'.repeat(this.pin.length);
		},
		pin: function () {
			return this.code_typed.substring(0, 4);
		}
	},
	watch: {
		code_typed: function (new_val, old_val) {
			/*console.log(new_val);*/
		}
	},
	created: function () {

		let is_logged = localStorage.getItem('is_logged');

		//automatic log if 
		if (is_logged) {
			this.login();
		}

		if (this.$route.params && this.$route.params.session_expired) {
			this.$bvToast.toast("A sua sessão expirou.", { title: 'Erro', variant: 'danger', solid: true });
		}

		var that = this;
		this.buttons = [
			{
				display_text: 1,
				class: 'button-number border-green-light',
				num: 1,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 2,
				class: 'button-number border-green-light',
				num: 2,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 3,
				class: 'button-number border-green-light',
				num: 3,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 4,
				class: 'button-number border-green-light',
				num: 4,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 5,
				class: 'button-number border-green-light',
				num: 5,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 6,
				class: 'button-number border-green-light',
				num: 6,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 7,
				class: 'button-number border-green-light',
				num: 7,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 8,
				class: 'button-number border-green-light',
				num: 8,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 9,
				class: 'button-number border-green-light',
				num: 9,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 'RESET',
				class: 'button-action bg-gray text-white font-bold',
				num: null,
				func: function (num) {
					that.code_typed = '';
				}
			},
			{
				display_text: 0,
				class: 'button-number border-green-light',
				num: 0,
				func: function (num) {
					that.code_typed += num;
				}
			},
			{
				display_text: 'ENTRAR',
				class: 'button-action bg-green-light text-white font-bold',
				num: null,
				func: function (num) {
					that.process_login(true)
				}
			},
		]
	}
}
</script>
<style scoped>
h2 {
	font-size: 40px;
	font-style: italic;
}

.len_typed {
	/*height: 33px;*/
	font-size: 36px;
	/*letter-spacing: 30px;*/
}

.login-container {
	max-width: 340px;
	width: 100%;
	/*margin-top: 120px; */
}

.button {
	width: 33.30%;
	font-size: 25px;
}

.button-inner {
	height: 100px;
	/*width: 160px;*/
}

.button-action {
	font-size: 17px;
}

.button-number {
	font-size: 25px;
}

.bg-gray {
	background-color: #394d4b;
}

@media (max-width: 575.98px) {
	.login-container {
		/*margin-top: 60px;*/
		width: 80%;
	}

	.button {}

	.button-inner {
		height: 80px;
	}
}
</style>